/**
 * 13Lune Swiper Carousel v3
 * Variant-per-slide, no tabs, manual product selection
 */
(function () {
  "use strict";

  // Initialize all carousel sections
  const sections = document.querySelectorAll(
    '[data-section-type="tl-newbest-carousel-3"]'
  );
  sections.forEach(function (section) {
    new CarouselSection(section);
  });

  /**
   * CarouselSection - Manages a single carousel section instance
   */
  function CarouselSection(sectionElement) {
    const section = sectionElement;
    const carousels = {};
    let resizeScheduled = false;

    // Initialize Swiper when library is ready
    function initSwipers() {
      if (!window.Swiper) {
        setTimeout(initSwipers, 100);
        return;
      }

      section
        .querySelectorAll(".tl-nbc__carousel.swiper")
        .forEach(function (carouselEl) {
          const key = carouselEl.getAttribute("data-carousel");

          // Skip if already initialized or no products
          if (carousels[key] || !carouselEl.querySelector(".tl-nbc__product")) {
            return;
          }

          try {
            // Swiper configuration
            const swiper = new Swiper(carouselEl, {
              // Mobile: show 1.7 slides
              slidesPerView: 1.7,
              spaceBetween: 24,

              // Navigation
              slidesPerGroup: 1,
              grabCursor: true,
              centerInsufficientSlides: true,

              // Responsive breakpoints
              breakpoints: {
                // Tablet and desktop: show 4 slides
                768: {
                  slidesPerView: 4,
                  spaceBetween: 24,
                },
              },

              // Auto-update on changes
              observer: true,
              observeParents: true,

              // Accessibility
              a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
              },

              on: {
                init: function () {},
                breakpoint: function (swiper, breakpointParams) {},
              },
            });

            // Store instance
            carousels[key] = swiper;

            // Setup navigation buttons
            setupNavigation(swiper, carouselEl);

            // Equalize card heights after init
            setTimeout(function () {
              equalizeCards();
            }, 100);
          } catch (e) {
            console.error("[13L Carousel v3] Error initializing Swiper:", e);
          }
        });
    }

    /**
     * Setup prev/next navigation buttons
     */
    function setupNavigation(swiper, carouselEl) {
      const wrapper = carouselEl.parentElement;
      const prevBtn = wrapper.querySelector(".tl-nbc__nav--prev");
      const nextBtn = wrapper.querySelector(".tl-nbc__nav--next");

      if (!prevBtn || !nextBtn) return;

      // Navigation handlers
      prevBtn.addEventListener("click", function () {
        swiper.slidePrev();
      });

      nextBtn.addEventListener("click", function () {
        swiper.slideNext();
      });

      // Update button states
      function updateNavButtons() {
        prevBtn.disabled = swiper.isBeginning;
        nextBtn.disabled = swiper.isEnd;
      }

      // Listen to Swiper events
      swiper.on("slideChange", updateNavButtons);
      swiper.on("init", updateNavButtons);
      swiper.on("resize", updateNavButtons);

      // Initial update
      updateNavButtons();
    }

    /**
     * Equalize product card heights across all slides
     */
    function equalizeCards() {
      try {
        const cards = section.querySelectorAll(".tl-nbc__product-inner");
        if (cards.length === 0) return;

        cards.forEach(function (card) {
          card.style.height = "auto";
        });

        let maxHeight = 0;
        cards.forEach(function (card) {
          const height = card.offsetHeight;
          if (height > maxHeight) maxHeight = height;
        });

        if (maxHeight > 0) {
          cards.forEach(function (card) {
            card.style.height = maxHeight + "px";
          });
        }

        Object.values(carousels).forEach(function (swiper) {
          if (swiper && !swiper.destroyed) {
            swiper.updateSize();
            swiper.updateSlides();
          }
        });
      } catch (e) {
        console.error("[13L Carousel v3] Error equalizing cards:", e);
      }
    }

    /**
     * Debounced equalize cards
     */
    function scheduleEqualize() {
      if (resizeScheduled) return;
      resizeScheduled = true;

      requestAnimationFrame(function () {
        resizeScheduled = false;
        equalizeCards();
      });
    }

    /**
     * Setup resize observer for card content changes
     */
    function setupResizeObserver() {
      if (!window.ResizeObserver) return;

      const observer = new ResizeObserver(scheduleEqualize);

      section.querySelectorAll(".tl-nbc__product-inner").forEach(function (card) {
        observer.observe(card);
      });
    }

    /**
     * Format money helper
     */
    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      return "$" + dollars;
    }

    /**
     * Update header cart count
     */
    function updateCartCount() {
      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          const itemCount = cart.item_count;

          document.dispatchEvent(
            new CustomEvent("cart:count-changed", {
              bubbles: true,
              detail: { count: itemCount },
            })
          );
        })
        .catch(function (error) {
          console.error("[13L Carousel v3] Error updating cart count:", error);
        });
    }

    /**
     * Setup add to cart buttons
     */
    function setupAddToCart() {
      section.querySelectorAll(".tl-nbc__add").forEach(function (btn) {
        if (btn.hasAttribute("data-atc-initialized")) {
          return;
        }
        btn.setAttribute("data-atc-initialized", "true");

        btn.addEventListener("click", function () {
          const variantId = btn.getAttribute("data-variant-id");

          if (!variantId || btn.disabled) {
            return;
          }

          if (btn.classList.contains("is-adding")) {
            return;
          }

          const originalLabel =
            btn.getAttribute("data-atc-label") || "ADD TO BAG";
          const addingLabel = "ADDING TO BAG...";
          const addedLabel = "ADDED ✓";

          btn.classList.add("is-adding");
          btn.disabled = true;
          btn.textContent = addingLabel;

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Add to cart failed");
              }
              return response.json();
            })
            .then(function (data) {
              btn.textContent = addedLabel;
              btn.classList.remove("is-adding");
              btn.classList.add("is-added");

              updateCartCount();

              document.dispatchEvent(
                new CustomEvent("cart:updated", { detail: data })
              );

              document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", { bubbles: true })
              );

              setTimeout(function () {
                btn.textContent = originalLabel;
                btn.classList.remove("is-added");
                btn.disabled = false;
              }, 2000);
            })
            .catch(function (error) {
              console.error("[13L Carousel v3] Add to cart error:", error);

              btn.textContent = originalLabel;
              btn.classList.remove("is-adding");
              btn.disabled = false;
            });
        });
      });
    }

    /**
     * Watch for Yotpo reviews loading
     */
    function watchYotpo() {
      if (!section.querySelector(".yotpo-widget-instance")) return;

      const yotpoObserver = new MutationObserver(function (mutations) {
        let hasNewContent = false;

        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length > 0) {
            hasNewContent = true;
          }
        });

        if (hasNewContent) {
          setTimeout(function () {
            equalizeCards();
          }, 300);
        }
      });

      section
        .querySelectorAll(".yotpo-widget-instance")
        .forEach(function (widget) {
          yotpoObserver.observe(widget, {
            childList: true,
            subtree: true,
          });
        });
    }

    /**
     * Initialize section
     */
    function init() {
      initSwipers();
      setupAddToCart();
      setupResizeObserver();
      watchYotpo();

      window.addEventListener("resize", scheduleEqualize);

      setTimeout(equalizeCards, 200);
    }

    init();
  }
})();
